(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["get-started-wizard-tapcart"]) return;
  try {
    
  let args = {
    "wz_nav_style": "progress", // dots, tabs, progress
    "wz_ori": "horizontal",
    "wz_buttons": ".wzd-buttons",
    "wz_button": ".wzd-button",
    "buttons": false,
    "navigation": 'all' // buttons, nav, all
  };

  const wizard = new Wizard(args);
  wizard.init();

  class TotalBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.totalBar = document.getElementById('total-bar');
      this.totalBarBounds = {};
      this.totalBarScrollTop = 0;
      this.onScrollHandlerTotalBar = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandlerTotalBar, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandlerTotalBar);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.totalBarBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.totalBar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= 0) {
        requestAnimationFrame(this.hide.bind(this));
      }
      this.totalBarScrollTop = scrollTop;
    }
    hide() {
      this.totalBar.classList.add('hide');
      this.totalBar.classList.remove('animate');
    }
    reveal() {
      this.totalBar.classList.add('animate');
      this.totalBar.classList.remove('hide');
    }
  }
  customElements.define('total-bar', TotalBar);

  class FilterBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.filterBar = document.getElementById('filter-bar');
      this.filterBarBounds = {};
      this.filterBarScrollTop = 0;
      this.onScrollHandlerFilterBar = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandlerFilterBar, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandlerFilterBar);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.filterBarBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.filterBar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var topFilter = document.getElementById('Wizard_TopFilterDropdown').getBoundingClientRect();
      if (scrollTop > topFilter.top + window.scrollY) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= topFilter.top + window.scrollY) {
        requestAnimationFrame(this.hide.bind(this));
      }
      this.filterBarScrollTop = scrollTop;
    }
    hide() {
      this.filterBar.classList.add('hide');
      this.filterBar.classList.remove('animate');
    }
    reveal() {
      this.filterBar.classList.add('animate');
      this.filterBar.classList.remove('hide');
    }
  }
  customElements.define('filter-bar', FilterBar);


  (function() {
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-started-wizard"]) return;
  try {
    
  let args = {
    "wz_nav_style": "progress", // dots, tabs, progress
    "wz_ori": "horizontal",
    "wz_buttons": ".wzd-buttons",
    "wz_button": ".wzd-button",
    "buttons": false,
    "navigation": 'all' // buttons, nav, all
  };

  const wizard = new Wizard(args);
  wizard.init();

  class TotalBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.totalBar = document.getElementById('total-bar');
      this.totalBarBounds = {};
      this.totalBarScrollTop = 0;
      this.onScrollHandlerTotalBar = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandlerTotalBar, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandlerTotalBar);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.totalBarBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.totalBar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= 0) {
        requestAnimationFrame(this.hide.bind(this));
      }
      this.totalBarScrollTop = scrollTop;
    }
    hide() {
      this.totalBar.classList.add('hide');
      this.totalBar.classList.remove('animate');
    }
    reveal() {
      this.totalBar.classList.add('animate');
      this.totalBar.classList.remove('hide');
    }
  }
  customElements.define('total-bar', TotalBar);

  class FilterBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.filterBar = document.getElementById('filter-bar');
      this.filterBarBounds = {};
      this.filterBarScrollTop = 0;
      this.onScrollHandlerFilterBar = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandlerFilterBar, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandlerFilterBar);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.filterBarBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.filterBar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var topFilter = document.getElementById('Wizard_TopFilterDropdown').getBoundingClientRect();
      if (scrollTop > topFilter.top + window.scrollY) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= topFilter.top + window.scrollY) {
        requestAnimationFrame(this.hide.bind(this));
      }
      this.filterBarScrollTop = scrollTop;
    }
    hide() {
      this.filterBar.classList.add('hide');
      this.filterBar.classList.remove('animate');
    }
    reveal() {
      this.filterBar.classList.add('animate');
      this.filterBar.classList.remove('hide');
    }
  }
  customElements.define('filter-bar', FilterBar);


  (function() {
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  })();

  document.addEventListener('rebuy:smartcart.hide', (event) => {
    window.location = '/';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ── StickyHeader — kept verbatim from Dawn ── */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      this.closeMegaMenu();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden', 'scrolled-past-header');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMegaMenu() {
      const mm = document.getElementById('ma-mega-menu');
      const btn = document.getElementById('ma-shop-btn');
      if (mm) { mm.hidden = true; mm.setAttribute('aria-hidden', 'true'); }
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ── MegaMenu — hover-intent + click ── */
  class MegaMenu {
    constructor() {
      this.btn = document.getElementById('ma-shop-btn');
      this.menu = document.getElementById('ma-mega-menu');
      if (!this.btn || !this.menu) return;

      this._openTimer = null;
      this._closeTimer = null;

      // Hover intent
      this.btn.addEventListener('mouseenter', () => this._scheduleOpen());
      this.btn.addEventListener('mouseleave', () => this._scheduleClose());
      this.menu.addEventListener('mouseenter', () => this._cancelClose());
      this.menu.addEventListener('mouseleave', () => this._scheduleClose());

      // Click toggle
      this.btn.addEventListener('click', () => {
        this.menu.hidden ? this._open() : this._close();
      });

      // Esc closes
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.menu.hidden) {
          this._close();
          this.btn.focus();
        }
      });

      // Click outside closes
      document.addEventListener('click', (e) => {
        if (!this.menu.hidden && !this.btn.contains(e.target) && !this.menu.contains(e.target)) {
          this._close();
        }
      });
    }

    _scheduleOpen() {
      this._cancelClose();
      this._openTimer = setTimeout(() => this._open(), 80);
    }

    _scheduleClose() {
      this._cancelOpen();
      this._closeTimer = setTimeout(() => this._close(), 150);
    }

    _cancelOpen() { clearTimeout(this._openTimer); }
    _cancelClose() { clearTimeout(this._closeTimer); }

    _open() {
      this.menu.hidden = false;
      this.menu.setAttribute('aria-hidden', 'false');
      this.btn.setAttribute('aria-expanded', 'true');
    }

    _close() {
      this.menu.hidden = true;
      this.menu.setAttribute('aria-hidden', 'true');
      this.btn.setAttribute('aria-expanded', 'false');
    }
  }

  /* ── NavPopover — account + currency ── */
  class NavPopover {
    constructor(btnId, popoverId) {
      this.btn = document.getElementById(btnId);
      this.popover = document.getElementById(popoverId);
      if (!this.btn || !this.popover) return;

      this.btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.popover.hidden ? this._open() : this._close();
      });

      document.addEventListener('click', (e) => {
        if (!this.popover.hidden && !this.btn.contains(e.target) && !this.popover.contains(e.target)) {
          this._close();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.popover.hidden) {
          this._close();
          this.btn.focus();
        }
      });
    }

    _open() {
      // Close other popovers first
      document.querySelectorAll('.ma-nav-popover:not([hidden])').forEach(p => {
        p.hidden = true;
        p.setAttribute('aria-hidden', 'true');
      });
      document.querySelectorAll('[aria-expanded="true"].ma-nav-account-btn, [aria-expanded="true"].ma-nav-currency-btn').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
      });

      this.popover.hidden = false;
      this.popover.setAttribute('aria-hidden', 'false');
      this.btn.setAttribute('aria-expanded', 'true');
    }

    _close() {
      this.popover.hidden = true;
      this.popover.setAttribute('aria-hidden', 'true');
      this.btn.setAttribute('aria-expanded', 'false');
    }
  }

  /* Currency row — auto-submit on click */
  function initCurrencyRows() {
    const form = document.getElementById('NavCurrencyForm');
    const submitBtn = document.getElementById('NavCurrencySubmit');
    if (!form || !submitBtn) return;

    form.querySelectorAll('.ma-pop-currency-row').forEach((row) => {
      row.addEventListener('click', () => {
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          submitBtn.click();
        }
      });
    });
  }

  /* ── MobileDrawer ── */
  class MobileDrawer {
    constructor() {
      this.drawer = document.getElementById('ma-mobile-drawer');
      this.scrim = document.getElementById('ma-mobile-scrim');
      this.hamburger = document.getElementById('ma-hamburger-btn');
      this.closeBtn = document.getElementById('ma-drawer-close-btn');
      this.backBtn = document.getElementById('ma-drawer-back-btn');
      this.shopBtn = document.getElementById('ma-drawer-shop-btn');
      this.logoWrap = document.getElementById('ma-drawer-header-logo');
      this.viewRoot = document.getElementById('ma-drawer-view-root');
      this.viewStore = document.getElementById('ma-drawer-view-store');

      if (!this.drawer) return;

      this.hamburger && this.hamburger.addEventListener('click', () => this.open());
      this.closeBtn && this.closeBtn.addEventListener('click', () => this.close());
      this.scrim && this.scrim.addEventListener('click', () => this.close());
      this.shopBtn && this.shopBtn.addEventListener('click', () => this.drillIn());
      this.backBtn && this.backBtn.addEventListener('click', () => this.drillOut());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.getAttribute('aria-hidden') === 'false') {
          this.close();
        }
      });
    }

    open() {
      this.drawer.setAttribute('aria-hidden', 'false');
      this.scrim && this.scrim.setAttribute('aria-hidden', 'false');
      this.hamburger && this.hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.drawer.setAttribute('aria-hidden', 'true');
      this.scrim && this.scrim.setAttribute('aria-hidden', 'true');
      this.hamburger && this.hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      // Return to root view
      this.drillOut();
    }

    drillIn() {
      this.viewRoot && this.viewRoot.classList.remove('ma-mobile-drawer__view--active');
      this.viewStore && this.viewStore.classList.add('ma-mobile-drawer__view--active');
      if (this.logoWrap) this.logoWrap.hidden = true;
      if (this.backBtn) this.backBtn.hidden = false;
    }

    drillOut() {
      this.viewStore && this.viewStore.classList.remove('ma-mobile-drawer__view--active');
      this.viewRoot && this.viewRoot.classList.add('ma-mobile-drawer__view--active');
      if (this.logoWrap) this.logoWrap.hidden = false;
      if (this.backBtn) this.backBtn.hidden = true;
    }
  }

  /* ── Mobile search ── */
  function initMobileSearch() {
    const btn = document.getElementById('ma-mobile-search-btn');
    const overlay = document.getElementById('ma-mobile-search-overlay');
    const cancelBtn = document.getElementById('ma-mobile-search-cancel');
    const input = document.getElementById('ma-mobile-search-input');
    if (!btn || !overlay) return;

    btn.addEventListener('click', () => {
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      btn.classList.add('ma-mobile-icon-btn--active');
      setTimeout(() => input && input.focus(), 50);
    });

    const close = () => {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      btn.classList.remove('ma-mobile-icon-btn--active');
      if (input) input.value = '';
    };

    cancelBtn && cancelBtn.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });
  }

  /* ── Desktop search pill collapse on blur ── */
  function initDesktopSearch() {
    const form = document.querySelector('.ma-nav-search__form');
    const input = form && form.querySelector('.ma-nav-search__input');
    if (!input) return;

    // Width is CSS-driven via :focus-within — nothing extra needed here
    // but we keep this stub for future predictive-search integration
  }

  /* ── Cart badge sync ────────────────────────────────────────────────────────
     Rebuy and other apps update the cart via direct API calls without firing
     Dawn events, so we poll /cart.js every 3s as the primary mechanism.
     Event listeners are kept as an instant fast-path for apps that do fire them.
     ─────────────────────────────────────────────────────────────────────────── */
  function initCartBadge() {
    var initialBadge = document.querySelector('#cart-icon-bubble .ma-nav-cart-badge');
    let lastCount = initialBadge ? (parseInt(initialBadge.textContent, 10) || 0) : 0;

    function setBadge(btn, cls, count) {
      if (!btn) return;
      let badge = btn.querySelector('.' + cls);
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = cls;
          btn.appendChild(badge);
        }
        badge.textContent = count > 99 ? '99+' : count;
      } else if (badge) {
        badge.remove();
      }
    }

    function updateBadges(count) {
      setBadge(document.getElementById('cart-icon-bubble'),        'ma-nav-cart-badge',    count);
      setBadge(document.getElementById('cart-icon-bubble-mobile'), 'ma-mobile-cart-badge', count);
      lastCount = count;
    }

    function refreshCount() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart.item_count !== lastCount) updateBadges(cart.item_count);
        })
        .catch(function() {});
    }

    // Primary: fired by ma-cart-drawer.js after every cart operation
    document.addEventListener('ma:cart.updated', (e) => {
      const count = e.detail && e.detail.item_count != null ? e.detail.item_count : null;
      if (count !== null && count !== lastCount) updateBadges(count);
    });

    // Fallback poll every 3s — catches anything ma-cart-drawer.js doesn't cover
    setInterval(() => { if (!document.hidden) refreshCount(); }, 3000);
  }

  /* ── Mobile cart — proxy to desktop cart button so drawer/notification fires ── */
  function initMobileCart() {
    const mobileCart = document.getElementById('cart-icon-bubble-mobile');
    const desktopCart = document.getElementById('cart-icon-bubble');
    if (!mobileCart) return;

    mobileCart.addEventListener('click', () => {
      if (desktopCart) {
        desktopCart.click();
      } else {
        window.location.href = '{{ routes.cart_url }}';
      }
    });
  }

  /* ── Boot ── */
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu();
    new NavPopover('ma-account-btn', 'ma-account-popover');
    new NavPopover('ma-currency-btn', 'ma-currency-popover');
    new MobileDrawer();
    initCurrencyRows();
    initMobileSearch();
    initDesktopSearch();
    initMobileCart();
    initCartBadge();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe"]) return;
  try {
    
class TotalBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log('connected callback');
    this.totalBar = document.getElementById('total-bar');
    this.totalBarBounds = {};
    this.testimonials = document.getElementById('testimonials-heading-block');
    this.totalBarScrollTop = 0;
    this.onScrollHandlerTotalBar = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandlerTotalBar, false);
    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandlerTotalBar);
  }

  createObserver() {
    console.log('create observer');
    let observer = new IntersectionObserver((entries, observer) => {
      this.totalBarBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.totalBar);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 0) {
      requestAnimationFrame(this.reveal.bind(this));
    } else
      if (scrollTop <= 0) { requestAnimationFrame(this.hide.bind(this)); } this.totalBarScrollTop=scrollTop; 
  } 
    
  hide() {
    this.totalBar.classList.add('hide'); this.totalBar.classList.remove('animate'); 
  } 
  reveal() {
    this.totalBar.classList.add('animate'); this.totalBar.classList.remove('hide'); 
  } 
} 
customElements.define('total-bar', TotalBar); 
  
  
  } catch(e) { console.error(e); }
})();
})();
